import {inject, Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ExceptionService} from '../error/exception.service';
import {BaseError} from '../../models/error/BaseError';
import {ErrorMessageService} from '../error/error-message.service';
import {TenantService} from '../tenant/tenant.service';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    private exceptionService: ExceptionService = inject(ExceptionService);
    private errorMessageService: ErrorMessageService = inject(ErrorMessageService);
    private tenantService: TenantService = inject(TenantService);

    constructor() {
    }

    public getTechnicalErrors(maxAmountOfMessages: number): Observable<BaseError[]> {
        return this.exceptionService.getMostRecentErrorItems(maxAmountOfMessages);
    }

    public getFunctionalErrors(maxAmountOfMessages: number): Observable<BaseError[]> {
        return this.errorMessageService.getMostRecentErrorItems(maxAmountOfMessages);
    }

    public getTotalAmountOfTenants(): Observable<number> {
        return this.tenantService.getTotalAmountOfTenants();
    }

    public getTotalAmountOfTenantApplications(): Observable<number> {
        return this.tenantService.getTotalAmountOfTenantApplications();
    }
}
